import { LinearProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { isEmpty } from "lodash";
import React from "react";
import { useLocation } from "react-router-dom";
import TableSet from "components/tableSetExplorer/TableSet";
import { useCalculationInputData, useQueryInputSchema } from "./inputDataHooks";

const useStyles = makeStyles(theme => ({
  tableSetWrapper: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    border: `solid 1px rgba(0,0,0,0.12)`
  }
}));

const InputDataTableSet = ({ useCaseKey, useCaseVersion }) => {
  const location = useLocation();
  const dataKey = location.state.dataKey;
  const { tableSetWrapper } = useStyles({});
  const {
    data: { inputSchema, inputColumnDefs, inputDataAddress, loadingData }
  } = useQueryInputSchema({
    useCaseKey,
    useCaseVersion,
    keys: [dataKey]
  });
  const { loadInputData } = useCalculationInputData();
  return (
    <div className={tableSetWrapper}>
      {isEmpty(inputSchema) || loadingData ? (
        <LinearProgress />
      ) : (
        <TableSet
          tablesSchema={inputSchema}
          dataKey={dataKey}
          useCaseVersion={useCaseVersion}
          useCaseKey={useCaseKey}
          loadData={loadInputData}
          columnDefs={inputColumnDefs}
          dataType="input"
          chartSources="use-case-input"
          dataAddress={inputDataAddress}
        />
      )}
    </div>
  );
};

export default InputDataTableSet;
